export const getMultipleValuesAsText = (v: Array<string>) => {
  // @ts-ignore
  return new Intl.ListFormat("en", { style: "narrow" }).format(
    v.filter(Boolean)
  );
};

export const getMultipleAddressAsText = (v: Array<string>) => {
  return v.join(' ').trim();
};
